import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { CheckIcon, CircleIcon, } from '@/components/ui/SvgIcon/Variable/SvgIconComponents';
import { Text } from '@/components/ui/Typography/Body/Text';
const STEP_STATUS_DONE = 'done';
const STEP_STATUS_CURRENT = 'current';
const STEP_STATUS_NOT_YET = 'not_yet';
/**
 * ステップ表示用コンポーネント
 * @param props
 * @returns
 */
export const Stepper = (props) => {
    const { className = '', currentIndex = 0, loading = false, stepTexts } = props;
    const lastIndex = useMemo(() => stepTexts.length - 1, [stepTexts]);
    /** 各ステップの文言と状態の配列 */
    const steps = useMemo(() => stepTexts.map((text, index) => {
        if (loading) {
            return { status: STEP_STATUS_NOT_YET, text };
        }
        if (currentIndex > index || currentIndex >= lastIndex) {
            return { status: STEP_STATUS_DONE, text };
        }
        if (index === currentIndex) {
            return { status: STEP_STATUS_CURRENT, text };
        }
        return { status: STEP_STATUS_NOT_YET, text };
    }), [currentIndex, lastIndex, loading, stepTexts]);
    /** 表示中の項目 */
    const current = useMemo(() => (Object.assign(Object.assign({}, steps[currentIndex]), { isLast: currentIndex === lastIndex })), [currentIndex, lastIndex, steps]);
    return (_jsxs("div", Object.assign({ className: className }, { children: [_jsx("ul", Object.assign({ className: 'flex flex-nowrap justify-between' }, { children: steps.map(({ status, text }, index) => {
                    const isDone = status === STEP_STATUS_DONE;
                    const isCurrent = status === STEP_STATUS_CURRENT;
                    const isNotYet = status === STEP_STATUS_NOT_YET;
                    return (_jsxs("li", Object.assign({ className: 'flex flex-col items-center w-full' }, { children: [_jsxs("div", Object.assign({ className: clsx('flex items-center justify-center', 'relative z-10 w-[28px] h-[28px]', 'bg-gray-50', 'border-solid border-2 rounded-full', {
                                    'border-blue-gray-100': isNotYet,
                                    'border-gray-300': isDone,
                                    'border-navy-100': isCurrent,
                                }) }, { children: [isCurrent && (_jsx(CircleIcon, { className: 'text-[11px]', color: 'primary', size: 'none' })), isDone && (_jsx(CheckIcon, { className: 'text-[13px] text-gray-300', color: 'none', size: 'none' }))] })), _jsx(Text, Object.assign({ className: clsx('hidden sm:block sm:mt-8 px-4'), color: isCurrent ? 'primary' : 'inactive', isBold: isCurrent, size: 'sm' }, { children: text })), _jsx("span", { className: clsx('relative top-[16px] left-1/2 -order-1', 'block h-[2px]', index !== lastIndex ? 'w-full' : 'w-0', isDone ? 'bg-gray-300' : 'bg-blue-gray-100') })] }), text));
                }) })), _jsx(Text, Object.assign({ className: 'block sm:hidden mt-8 sm:mt-0 text-center', color: current.isLast || loading ? 'inactive' : 'primary', isBold: !(current.isLast || loading), size: 'sm' }, { children: current.text }))] })));
};
